import { render, staticRenderFns } from "./ListMixin.vue?vue&type=template&id=a08ae616&scoped=true&"
import script from "./ListMixin.vue?vue&type=script&lang=js&"
export * from "./ListMixin.vue?vue&type=script&lang=js&"
import style0 from "./ListMixin.vue?vue&type=style&index=0&id=a08ae616&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08ae616",
  null
  
)

export default component.exports